// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"13":"64e1edb8","201":"ac64c1bf","314":"53f2d325","814":"3bef1483","963":"1d023f4d"}[chunkId] + ".css";
};